export enum InvestigationNonResponseDecision {
	RecordNonResponseAndProceed = 1,
	Renotify = 2,
	GrantAdditionalDeadline = 3,
}
